module.exports = __webpack_public_path__ + "media/uk_ua_s2_Veronika.5d627617.oga";